import {createReducer, on} from '@ngrx/store'
import {daneKlientaStanPoczatkowy} from './daneKlienta.stan-poczatkowy';
import {DaneKlienta} from '../../../services/samoobsluga/types/dane-klienta';
import {pobierzDaneZgloszeniaSuccess} from '../../../../init/store/init.actions';
import {kliknietoRozpocznijSuccess} from '../../../../samoobsluga/strona-startowa/store/strona-startowa.actions';
import {zapiszStorePoZmianieStanuNaKwotaUkryta
} from '../../../../samoobsluga/proces-decyzji/ekran-braku-prezentacji-kwoty-po-kalkulacji/store/ekran-braku-prezentacji-kwoty-po-kalkulacji.actions';
import {
  kliknietoKalkulujSuccess,
} from '../../../../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/store/ekran-podsumowania.actions';
import {
  pominEkranRoszczenIPrzekierujNaEkranBrakuPrezentacjiKwoty,
  pominEkranRoszczenIPrzekierujWZaleznosciOdKwotyDocelowej
} from '../../../../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/store/krok-po-kalkulacji/krok-po-kalkulacji.actions';

export const daneKlientaReducer = createReducer(
  daneKlientaStanPoczatkowy,
  on(pobierzDaneZgloszeniaSuccess, kliknietoRozpocznijSuccess,
    kliknietoKalkulujSuccess,
    zapiszStorePoZmianieStanuNaKwotaUkryta, pominEkranRoszczenIPrzekierujWZaleznosciOdKwotyDocelowej,
    pominEkranRoszczenIPrzekierujNaEkranBrakuPrezentacjiKwoty,
    (state, action): DaneKlienta => {
      return ({
        ...state,
        ...action.daneZgloszenia.daneKlienta
      })
    }),
)
